import { Link } from '@backstage/core-components';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
  AISE_MARKETPLACE_LINK_TEXT,
  AISE_MARKETPLACE_REPO_URL,
  AISE_MARKETPLACE_TOOLTIP,
} from '../../components/aise-marketplace/constants';

const useStyles = makeStyles(
  theme => ({
    item: {
      height: 48,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.navigation.color,
      padding: theme.spacing(2.5),
      cursor: 'pointer',
      '&:hover': {
        background:
          theme.palette.navigation.navItem?.hoverBackground || '#6f6f6f',
        color: theme.palette.navigation.selectedColor,
      },
    },
    label: {
      margin: theme.spacing(1.75),
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.body2.fontSize,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 1,
    },
  }),
  { name: 'AiseMarketplaceSidebarSubmenuItem' },
);

/** AISE Marketplace link in the sidebar flyout with custom hover text. */
export function AiseMarketplaceSidebarSubmenuItem() {
  const classes = useStyles();

  return (
    <Box>
      <Tooltip
        title={AISE_MARKETPLACE_TOOLTIP}
        enterDelay={500}
        enterNextDelay={500}
      >
        <Link
          to={AISE_MARKETPLACE_REPO_URL}
          underline="none"
          className={classNames(classes.item)}
        >
          <Typography
            variant="subtitle1"
            component="span"
            className={classes.label}
          >
            {AISE_MARKETPLACE_LINK_TEXT}
          </Typography>
        </Link>
      </Tooltip>
    </Box>
  );
}
